import React from "react";
import { Link } from "react-router";
import MenuItem from "material-ui/MenuItem";
import Divider from "material-ui/Divider";
import Drawer from "material-ui/Drawer";
import ArrowDropRight from "material-ui/svg-icons/navigation-arrow-drop-right";
import Subheader from "material-ui/Subheader";
import Avatar from "material-ui/Avatar";
import md5 from "js-md5";
import ListItem from "material-ui/List/ListItem";
import {connect} from 'react-redux';
import { withRouter } from 'react-router'
import { getResponse } from "../reducer/response";
import { signOut } from "../actions/auth";
import DebugSwitch from "./DebugSwitch";
import DropDownMenu from 'material-ui/DropDownMenu';
import { updateTrForResponse } from '../actions/translation';

class LeftMenuButton extends React.Component {

  render() {
    const { open, onRequestChange, inResults, readOnly, responseID, isAdmin, email, name } = this.props;
    let trIDForResponse = this.props.trIDForResponse;
    if(!trIDForResponse){trIDForResponse = -1} //default to english
    return (
      <div style={{ position: "absolute", left: 155, top: 18, fontSize: 24 }}>
        <Drawer
          docked={false}
          width={200}
          open={open}
          onRequestChange={onRequestChange}
        >
          {email ? (
            <div>
              <ListItem
                leftAvatar={
                  <Avatar
                    size={35}
                    src={`https://www.gravatar.com/avatar/${md5(
                      email
                    )}?d=mm`}
                  />
                }
                style={{
                  padding: "20px 16px 20px 62px",
                  textOverflow: "ellipsis",
                  width: 120,
                  overflow: "hidden",
                  whiteSpace: "nowrap"
                }}
                disabled
              >
                {name || email}
              </ListItem>
              <MenuItem
                style={{ paddingLeft: 10 }}
                onClick={this.close}
                containerElement={<Link to="/home" />}
              >
                My Fisheries
              </MenuItem>
              <MenuItem
                style={{ paddingLeft: 10 }}
                onClick={this.signOut}
                containerElement={<Link to="/" />}
              >
                Sign Out
              </MenuItem>
            </div>
          ) : (
            <MenuItem
              onClick={this.close}
              containerElement={<Link to="/" />}
            >
              Login
            </MenuItem>
          )}
          <Divider />
          {inResults ? (
            <span>
              <Subheader>Results</Subheader>
              <MenuItem
                onClick={this.close}
                containerElement={
                  <Link
                    to={`/questionnaire/results/${
                      readOnly ? responseID + "/" : ""
                    }monitoring`}
                  />
                }
              >
                Summary
              </MenuItem>
              <MenuItem
                onClick={this.close}
                containerElement={
                  <Link
                    to={`/questionnaire/results/${
                      readOnly ? responseID + "/" : ""
                    }answers`}
                  />
                }
              >
                Answers
              </MenuItem>
              <MenuItem
                primaryText="Option Lists"
                rightIcon={<ArrowDropRight />}
                menuItems={[
                  <MenuItem
                    onClick={this.close}
                    primaryText="Data Collection"
                    containerElement={
                      <Link
                        to={`/questionnaire/results/${
                          readOnly ? responseID + "/" : ""
                        }options/monitoring`}
                      />
                    }
                  />,
                  <MenuItem
                    onClick={this.close}
                    primaryText="Assessment"
                    containerElement={
                      <Link
                        to={`/questionnaire/results/${
                          readOnly ? responseID + "/" : ""
                        }options/assessment`}
                      />
                    }
                  />,
                  <MenuItem
                    onClick={this.close}
                    primaryText="Management Measures"
                    containerElement={
                      <Link
                        to={`/questionnaire/results/${
                          readOnly ? responseID + "/" : ""
                        }options/controlRules`}
                      />
                    }
                  />
                ]}
              />
              <Divider />
            </span>
          ) : null}
          <MenuItem
            primaryText="Reference"
            rightIcon={<ArrowDropRight />}
            menuItems={[
              <MenuItem
                onClick={this.close}
                primaryText="Data Collection"
                containerElement={
                  <Link to={`/questionnaire/reference/monitoring`} />
                }
              />,
              <MenuItem
                onClick={this.close}
                primaryText="Assessment"
                containerElement={
                  <Link to={`/questionnaire/reference/assessment`} />
                }
              />,
              <MenuItem
                onClick={this.close}
                primaryText="Management Measures"
                containerElement={
                  <Link to={`/questionnaire/reference/controlRules`} />
                }
              />
            ]}
          />
          <MenuItem onClick={this.contactUs}>Contact Us</MenuItem>
          {isAdmin ? (
            <MenuItem
              onClick={this.close}
              containerElement={<Link to="/admin" />}
            >
              Admin
            </MenuItem>
          ) : null}
          { isAdmin ? <DebugSwitch /> : ""}
          {(this.props.responseID && this.props.responseID !== "123") ? <div>
            <span style={{fontSize:16, marginLeft:15}}>Question Langauge</span>
            <DropDownMenu
              style={{width: 200, float:"right"}}
              value={trIDForResponse}
              onChange={this.onTrDropDownMenuChange.bind(this)}
            >
              <MenuItem value={-1} primaryText="English" />
              {this.props.translationList.map(lang => <MenuItem key={lang.id} value={lang.id} primaryText={lang.title} />)}

            </DropDownMenu>

          </div>: null}
        </Drawer>
      </div>
    );
  }

  signOut = () => {
    this.props.onSignOut();
    this.props.router.push("/");
  };

  contactUs() {
    this.props.onRequestChange(false)
    window.open("mailto:support@fishpath.org", "_blank");
  }

  close = () => {
    this.props.onRequestChange(false)
  }

  onTrDropDownMenuChange = (event, index, value) => {
    this.props.handleTrChangeForResponse(value, this.props.responseID)
  }
}

const mapStateToProps = (state, ownProps) => {
  let readOnly = true;
  let response = getResponse(state);
  let responseID = response ? response.metadata.id : '123';
  if (response && response.metadata.email === state.auth.email) {
    readOnly = false;
  }
  let inResults = ownProps.inResults;
  let section = false;
  if (inResults) {
    section = ownProps.params.idOrSection;
    if (inResults && readOnly) {
      section = ownProps.params.section;
    }
  }

  return {
    responseID: responseID,
    inResults,
    section,
    readOnly,
    email: state.auth.email,
    name: state.auth.name,
    isAdmin: state.auth.isAdmin,
    translationList: state.translationList.filter(tr => tr.published),
    trIDForResponse: response ? response.userEdits.trIDForResponse : -1,
  }

}

let mapDispatchToProps = (dispatch) => {
  return {
    onSignOut: () => dispatch(signOut()),
    handleTrChangeForResponse: (trID, responseID) => dispatch(updateTrForResponse(trID, responseID))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LeftMenuButton));
